import React from 'react';
import { connect } from 'react-redux';
import {
  VictoryChart,
  VictoryStack,
  VictoryBar,
  VictoryAxis,
  VictoryLabel,
} from 'victory';
import { getTenantState } from '../../../store/selectors';
import { reportingCopy } from '../../../copy/advisor-dashboard/advisor-dashboard-base.json';
import BoxWithShadowAndUnderline from '../basic-style-components/BoxWithShadowAndUnderline';
import EcapCompletionChartPopover from './EcapCompletionChartPopover';

export function EcapCompletionChart(props) {
  const customFont = { fontSize: 30, fontFamily: 'Roboto' };
  return (
    <div className="ecap-completion-chart">
      <BoxWithShadowAndUnderline tenant={props.tenant}>
        <div className="ecap-completion-chart__header">
          <div className="ecap-completion-chart__heading">
            {props.highSchool}
          </div>
        </div>
        <div className="ecap-completion-chart__container">
          <EcapCompletionChartPopover data={props.data} />
          <div className="ecap-completion-chart__chart">
            <VictoryChart domainPadding={{ x: 85 }} height={450}>
              <VictoryStack
                colorScale={reportingCopy.ecapCompletions.colorScale}
                labels={({ datum }) => datum._y1}
                labelComponent={<VictoryLabel style={customFont} />}
              >
                {Object.entries(props.data).map(([year, counts]) => {
                  return (
                    <VictoryBar
                      barWidth={60}
                      data={[
                        { x: 'Incomplete', y: counts.incomplete },
                        { x: 'Complete', y: counts.complete },
                      ]}
                      key={year}
                    />
                  );
                })}
              </VictoryStack>
              <VictoryAxis
                style={{ tickLabels: { fontSize: 30, fontFamily: 'Roboto' } }}
              />
            </VictoryChart>
          </div>
        </div>
      </BoxWithShadowAndUnderline>
    </div>
  );
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  return { tenant };
}

export default connect(mapStateToProps)(EcapCompletionChart);
